import { render, staticRenderFns } from "./CachePage.vue?vue&type=template&id=60386d12&scoped=true"
import script from "./CachePage.vue?vue&type=script&lang=js"
export * from "./CachePage.vue?vue&type=script&lang=js"
import style0 from "./CachePage.vue?vue&type=style&index=0&id=60386d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60386d12",
  null
  
)

export default component.exports